/* @ngInject */
function IntegrationsController ($scope, $rootScope, $translate, AdminService, ToastService, ConfirmationModalService) {
  $scope.apiKey = ''

  const api = {
    _regenerateApiKey
  }
  this.getApi = () => api

  activate()
  function activate () {
    $rootScope.getUserCompany().then(company => {
      $scope.apiKey = company.apiKey
    })
  }

  function _regenerateApiKey () {
    AdminService.regenerateApiKey().then((data) => {
      $scope.apiKey = data?.apiKey
    }).catch((err) => {
      console.error(err)
      ToastService.showErrorToast($translate.instant('adminIntegrations.errorToast'))
    })
  }

  $scope.regenerateApiKey = () => {
    ConfirmationModalService.createModal({
      description: $translate.instant('adminIntegrations.confirmationDescription'),
      onConfirm: api._regenerateApiKey
    })
  }
}

export { IntegrationsController }
